import { ChevronRight } from 'lucide-react';
import { Icon, type LucideIcon } from '../ui/icon';
import { Sheet } from '../ui/sheet';

export interface SchnellErfassenOption {
  id: string;
  /** Was erfasst wird, als Substantiv: „Notiz“, „Anruf“, „Aufgabe“. */
  label: string;
  /** Kurzer Hinweis darunter: „Zu einem Kunden, Text genügt“. */
  hint?: string;
  icon: LucideIcon;
}

export interface SchnellErfassenProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  options: SchnellErfassenOption[];
  /** Schließt die Auswahl und meldet die Wahl. Die App öffnet danach ihr Formular, meist ein eigenes Sheet. */
  onWahl: (id: string) => void;
}

/**
 * Was das „+“ der Tab-Leiste öffnet: erst wählen, was erfasst wird, dann ein
 * kurzes Formular der App. Große Zeilen für den Daumen. (Ergänzung, README „Mobil“.)
 */
export function SchnellErfassen({ open, onOpenChange, options, onWahl }: SchnellErfassenProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange} title="Schnell erfassen">
      <ul className="-mx-2 flex flex-col">
        {options.map((o) => (
          <li key={o.id}>
            <button
              type="button"
              onClick={() => {
                onOpenChange(false);
                onWahl(o.id);
              }}
              className="flex min-h-14 w-full cursor-pointer items-center gap-3 rounded-lg px-2 py-2.5 text-left transition-colors duration-[120ms] hover:bg-accent"
            >
              <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-muted text-highlight">
                <Icon icon={o.icon} size={20} />
              </span>
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="t-body-strong">{o.label}</span>
                {o.hint && <span className="t-small text-muted-foreground">{o.hint}</span>}
              </span>
              <Icon icon={ChevronRight} className="text-muted-foreground" />
            </button>
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
